/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · German (de) · Journal / blog page
   English is the source of truth in blog.html; this file supplies the
   German counterpart for each blog.* data-i18n key. Missing keys fall
   back to English automatically (see i18n.js).

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) stay in English. Informal singular "du".
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.de = window.TD_I18N.de || {};
  Object.assign(window.TD_I18N.de, {

    /* ── Footer · extra link not on the homepage ── */
    'footer.learn.about': 'Über Dr. Ronlán',

    /* ── Page head ── */
    'blog.eyebrow': 'Journal',
    'blog.title': 'Notizen aus dem<br><em>Labor.</em>',
    'blog.intro': 'Die Wissenschaft, die Seren und die Pflegerituale bei Transderma: dreißig Jahre Forschung, übersetzt für das Regal im Badezimmer.',

    /* ── Filter bar ── */
    'blog.filter.all': 'Alle',
    'blog.filter.science': 'Wissenschaft',
    'blog.filter.ingredients': 'Inhaltsstoffe',
    'blog.filter.routines': 'Routinen',
    'blog.filter.longevity': 'Langlebigkeit',

    /* ── Shared "Read" link ── */
    'blog.read': 'Lesen <span class="arr">→</span>',

    /* ── Coming-soon labels (theme template; articles not yet live) ── */
    'blog.soon': 'Bald verfügbar',
    'blog.notice.upcoming': 'Artikel erscheinen bald · trag dich unten ein, um benachrichtigt zu werden',

    /* ── Article 1 (featured) ── */
    'blog.a1.cat': 'Wissenschaft',
    'blog.a1.time': '7 Min. Lesezeit',
    'blog.a1.date': 'Apr 2026',
    'blog.a1.title': 'Warum <em>wasserfreie</em> Hautpflege wirklich funktioniert, und warum die meisten Seren es nicht tun.',
    'blog.a1.excerpt': 'Zwischen sechzig und neunzig Prozent des Inhalts einer durchschnittlichen Serumflasche sind Wasser. Der Rest: Emulgatoren, Verdickungsmittel und Konservierungsstoffe. Wenn wir sagen, dass Transderma wasserfrei ist, meinen wir, dass jeder Tropfen aktive Formel ist. Hier ist die Chemie hinter dieser Entscheidung und warum das verändert, was wirklich auf der Haut ankommt.',
    'blog.a1.read': 'Artikel lesen <span class="arr">→</span>',

    /* ── Article 2 ── */
    'blog.a2.cat': 'Inhaltsstoffe',
    'blog.a2.time': '5 Min.',
    'blog.a2.title': 'Retinylpalmitat versus Retinol: ein sanfterer Weg zur Erneuerung.',
    'blog.a2.excerpt': 'Warum Serum A den Palmitat-Ester von Vitamin A verwendet: wie es sich in der Haut umwandelt, warum es mit Vitamin E stabilisiert wird und für wen es am besten passt.',

    /* ── Article 3 ── */
    'blog.a3.cat': 'Wissenschaft',
    'blog.a3.time': '6 Min.',
    'blog.a3.title': 'Transdermale Diffusion, erklärt für das Badezimmerregal.',
    'blog.a3.excerpt': 'Was "über das Stratum corneum hinaus" wirklich bedeutet, wie Squalan aktive Vitamine durch die äußere Hautschicht transportiert, und die tiefe Forschung hinter dem Namen.',

    /* ── Article 4 ── */
    'blog.a4.cat': 'Routinen',
    'blog.a4.time': '4 Min.',
    'blog.a4.title': 'Stell eine Transderma-Routine in fünf Schritten zusammen.',
    'blog.a4.excerpt': 'Morgen, Abend, Anwendungsreihenfolge, und wie du Serum M hinzufügst, ohne den Wirkstoff darunter zu verdünnen. Der Rhythmus, der aus fünf Flaschen ein System macht.',

    /* ── Article 5 ── */
    'blog.a5.cat': 'Langlebigkeit',
    'blog.a5.time': '8 Min.',
    'blog.a5.title': 'Die Mitochondrien-Frage: warum Serum O das Serum der Langlebigkeit ist.',
    'blog.a5.excerpt': 'PQQ, Kreatin, B-Vitamine. Das Argument dafür, Hautalterung auf der Ebene der Zellenergie zu behandeln, und warum Mitochondrien-Unterstützung im Zentrum der markantesten Formel der Reihe steht.',

    /* ── Article 6 ── */
    'blog.a6.cat': 'Inhaltsstoffe',
    'blog.a6.time': '5 Min.',
    'blog.a6.title': 'Resveratrol, Piceid und die Wissenschaft hinter Aknemalen.',
    'blog.a6.excerpt': 'Wie vier Inhaltsstoffe (und kein Wasser) ungleichmäßigen Teint, Umweltschäden und Male angehen, die lange nach dem Verschwinden des Pickels bleiben.',

    /* ── Article 7 ── */
    'blog.a7.cat': 'Wissenschaft',
    'blog.a7.time': '6 Min.',
    'blog.a7.title': 'Ceramide, Cholesterin und der Lipidmörtel der Haut.',
    'blog.a7.excerpt': 'Warum eine Barriere, die ihre eigene Feuchtigkeit hält, das Ziel ist, und wie Serum M die Lipide ergänzt, die deine Haut bereits selbst herstellen kann.',

    /* ── Article 8 ── */
    'blog.a8.cat': 'Routinen',
    'blog.a8.time': '3 Min.',
    'blog.a8.title': 'Zwei Tropfen reichen. Das Argument gegen Übernutzung.',
    'blog.a8.excerpt': 'Ein konzentriertes, wasserfreies Serum verhält sich nicht wie eine Feuchtigkeitscreme mit 65 % Wasser. Warum weniger weiter reicht, wenn die Formel mit deiner Haut arbeitet, nicht gegen sie.',

    /* ── Newsletter ── */
    'blog.news.eyebrow': 'The Journal · Monatlich',
    'blog.news.title': 'Ein kurzer Brief <em>jeden Monat.</em>',
    'blog.news.body': 'Neue Artikel, dezente Produktneuigkeiten und, hin und wieder, ein Wort aus dem Labor. Keine Promotionen, keine Füllung. Eine durchdachte Notiz und ein Abmeldelink in jeder E-Mail.',
    'blog.news.placeholder': 'deine@email.com',
    'blog.news.aria': 'E-Mail-Adresse',
    'blog.news.button': 'Abonnieren'

  });
})();
